<div mwlCalendarPreviousView [(viewDate)]="viewDate" [view]="view" (viewDateChange)="onMonthNavigation()"></div>

<div>
    {{ viewDate | calendarDate:(view + 'ViewTitle'):currentLocale }}
</div>

<div mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="onMonthNavigation()"></div>

<mwl-calendar-month-view [viewDate]="viewDate" [events]="calendarEvents" [weekStartsOn]="weekStartOnDay" (beforeViewRender)="onBeforeCalendarRender($event)" (dayClicked)="onDateCalendarSelected($event)" [refresh]="refreshCalendar">
</mwl-calendar-month-view>